var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topHead"},[_vm._t("head",[_c('img',{attrs:{"src":require("../assets/images/fh.png"),"alt":""},on:{"click":function($event){return _vm.backBefor()}}})]),_vm._t("header")],2)}
var staticRenderFns = []

export { render, staticRenderFns }